import { diagnosticLog } from './diagnosticLogger';
import { isPlaybackStoppedForReload } from './webBundleMeta';
import { isRendererPlaybackBlockingWebReload } from '../transport/rendererPlaybackBlocksReload';

export async function shouldDeferBundleSkewReloadForPlayback(
  running: string,
  current: string,
): Promise<boolean> {
  if (!isPlaybackStoppedForReload() || await isRendererPlaybackBlockingWebReload()) {
    diagnosticLog('info', 'js:render', 'bundle_skew_reload_deferred_playback_active', {
      running,
      current,
    });
    return true;
  }
  return false;
}
